'use strict';
//QrInstanceModalController
/* @ngInject */
export default class QrInstanceModalController {
    constructor($scope, $uibModalInstance, apiKey) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.apiKey = apiKey;
    }

    cancel() {
        this.$uibModalInstance.close();
    }
}